import { render } from "./PartsAboutUs.vue?vue&type=template&id=10a41e36"
import script from "./PartsAboutUs.vue?vue&type=script&lang=js"
export * from "./PartsAboutUs.vue?vue&type=script&lang=js"

import exportComponent from "/Users/maru/Desktop/東野材木/hojokin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__